module.exports = __webpack_public_path__ + "img/a perfect day for errands.cb3f569d.png";